import { render, staticRenderFns } from "./ShowVideo.vue?vue&type=template&id=0a064a42&scoped=true"
import script from "./ShowVideo.vue?vue&type=script&lang=js"
export * from "./ShowVideo.vue?vue&type=script&lang=js"
import style0 from "./ShowVideo.vue?vue&type=style&index=0&id=0a064a42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a064a42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VOverlay})
